import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import ReactModal from 'react-modal';

type Props = {
  open: boolean;
  title: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteRosterModal = (props: Props) => {
  const { open, title, loading, onClose, onConfirm } = props;

  return (
    <ReactModal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <div className='flex flex-col items-center justify-center gap-8 px-12 py-8'>
        <div className='flex flex-col items-center justify-center gap-3'>
          <ErrorIcon />
          <p className='max-w-[244px] text-center text-lg text-[#1A1A1A] font-medium'>{title}</p>
          <p className='text-sm text-[#595959]'>
            Ensure to replace roster for the week deleted promptly
          </p>
        </div>
        <div className='flex items-center gap-5 mx-auto'>
          <Button
            variant='block'
            color='gray'
            className='w-[139px] h-[41px] !text-[#1A1A1A] !bg-[#F0F0F0] !border-[#F0F0F0]'
            onClick={onClose}>
            Cancel
          </Button>
          <Button
            color='primary'
            variant='block'
            className='w-[139px] h-[41px]'
            loading={loading}
            onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </ReactModal>
  );
};

export default DeleteRosterModal;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'hidden'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};
